import { jsx, jsxs } from "react/jsx-runtime";
import { forwardRef, memo } from "react";
const SvgGitHub = ({ title, titleId, ...props }, ref)=>/*#__PURE__*/ jsxs("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        focusable: "false",
        role: "img",
        ref: ref,
        "aria-labelledby": titleId,
        ...props,
        children: [
            title ? /*#__PURE__*/ jsx("title", {
                id: titleId,
                children: title
            }) : null,
            /*#__PURE__*/ jsx("path", {
                d: "M12 1C5.9225 1 1 5.92525 1 12C1 16.8611 4.1515 20.9833 8.52125 22.4362C9.07125 22.5398 9.27292 22.1997 9.27292 21.9073C9.27292 21.6461 9.26375 20.954 9.25917 20.0373C6.19933 20.701 5.554 18.5615 5.554 18.5615C5.0535 17.2919 4.33025 16.9528 4.33025 16.9528C3.33383 16.2708 4.40725 16.2845 4.40725 16.2845C5.51183 16.3615 6.09208 17.4175 6.09208 17.4175C7.07292 19.0996 8.667 18.6137 9.29583 18.3323C9.39483 17.621 9.67808 17.1361 9.9925 16.8611C7.54958 16.5861 4.982 15.6401 4.982 11.4253C4.982 10.2244 5.40825 9.24358 6.11408 8.47358C5.99033 8.19583 5.61908 7.0775 6.21033 5.56225C6.21033 5.56225 7.13158 5.26708 9.23533 6.68975C10.1153 6.445 11.0503 6.324 11.9853 6.3185C12.9203 6.324 13.8553 6.445 14.7353 6.68975C16.8253 5.26708 17.7466 5.56225 17.7466 5.56225C18.3378 7.0775 17.9666 8.19583 17.8566 8.47358C18.5578 9.24358 18.9841 10.2244 18.9841 11.4253C18.9841 15.6511 16.4128 16.5815 13.9653 16.8519C14.3503 17.1819 14.7078 17.8566 14.7078 18.8869C14.7078 20.3591 14.6941 21.5416 14.6941 21.8991C14.6941 22.1878 14.8866 22.5316 15.4503 22.4216C19.8513 20.9787 23 16.8538 23 12C23 5.92525 18.0748 1 12 1Z",
                fill: "currentColor"
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ forwardRef(SvgGitHub);
const Memo = /*#__PURE__*/ memo(ForwardRef);
const GitHub = Memo;
export { GitHub as default };
